import { ConfigSection } from '@components-fabric';
import { publicLayout } from '../_common/layout.public';
import { Error403Screen, Error404Dot1Screen, Error404Screen, Error500Screen } from '@components-common/errors';

/**
 * Configuration Section: errorsSection
 *
 * This configuration section defines the error screens for the application. It uses a public layout and is not protected,
 * making these error screens accessible regardless of authentication status.
 *
 * Properties:
 * @property {string} id - The unique identifier for this section, set to 'errors'.
 * @property {Object} layout - The layout component to use for this section, which is a public layout.
 * @property {boolean} protected - Indicates if the section requires authentication to access (false for this section).
 * @property {string} tmp - The template type to use for this section, set to 'basic'.
 * @property {Array} screens - An array of screen configurations included in this section.
 */
export const errorsSection: ConfigSection= {
  id: 'errors',
  layout: publicLayout,
  protected: false,
  tmp: 'basic',
  screens:[
  {
    id: 'not-found',
    Component: Error404Screen
  },
  {
    id: 'not_found_resource',
    Component: Error404Dot1Screen,
  },
  {
    id: 'forbidden',
    Component: Error403Screen,
    protected: false,
  },
  {
    id: 'internal-server-error',
    Component: Error500Screen
  },
  {
    id: 'security-alert',
    Component: Error403Screen
  },
]};
